import React, { useCallback, useState } from 'react';

import { Typography } from '@mui/material';

import { LoginView } from 'main/hooks/use-login-dialog/types';
import SignInFormContent from 'main/pages/components/LoginForm';
import RecoveryFormContent from 'main/pages/components/RecoveryForm';
import SignUpFormContent from 'main/pages/components/SignUpForm';

import useStyles from './styles';

interface Props {
    redirectUrl?: string;
    onSuccessLogin?: () => void;
}

const LoginForm: React.FC<Props> = ({ redirectUrl, onSuccessLogin }) => {
    const { classes } = useStyles();
    const [view, setView] = useState<LoginView>(LoginView.SIGN_IN);

    const switchToSignIn = useCallback(() => setView(LoginView.SIGN_IN), []);
    const switchToSignUp = useCallback(() => setView(LoginView.SIGN_UP), []);
    const switchToRecover = useCallback(() => setView(LoginView.RECOVER), []);

    return (
        <>
            <div>
                <div className={classes.subHeader}>
                    {view === LoginView.SIGN_IN && (
                        <>
                            <Typography variant="h2">Sign in</Typography>
                            Don`t have an account?{' '}
                            <span className={classes.link} onClick={switchToSignUp}>
                                Sign up
                            </span>
                        </>
                    )}
                    {view === LoginView.SIGN_UP && (
                        <>
                            <Typography variant="h2">Sign up</Typography>
                            Already have an account?{' '}
                            <span className={classes.link} onClick={switchToSignIn}>
                                Sign in
                            </span>
                        </>
                    )}
                    {view === LoginView.RECOVER && (
                        <>
                            <Typography variant="h2">Recover password</Typography>
                            Already have an account?{' '}
                            <span className={classes.link} onClick={switchToSignIn}>
                                Sign in
                            </span>
                        </>
                    )}
                </div>
            </div>

            {view === LoginView.SIGN_IN && (
                <>
                    <SignInFormContent
                        className={classes.formContent}
                        showHeader={false}
                        showRecover={false}
                        redirectUrl={redirectUrl}
                        onSuccess={onSuccessLogin}
                    />
                    <div className={classes.forgotPasswordButton} onClick={switchToRecover}>
                        {'Forgot password?'}
                    </div>
                </>
            )}
            {view === LoginView.SIGN_UP && (
                <SignUpFormContent className={classes.formContent} showHeader={false} redirectUrl={redirectUrl} />
            )}
            {view === LoginView.RECOVER && (
                <RecoveryFormContent className={classes.formContent} showHeader={false} redirectUrl={redirectUrl} />
            )}
        </>
    );
};

export default LoginForm;
